const paths = {
  compass: (
    <path
      d="M12 3.75a8.25 8.25 0 108.25 8.25A8.25 8.25 0 0012 3.75zm2.9 4.6l-1.1 4.39a1.5 1.5 0 01-1.1 1.1l-4.39 1.1 1.1-4.39a1.5 1.5 0 011.1-1.1z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  map: (
    <path
      d="M9 3.75l6-2.25v16.5l-6 2.25L3 18V1.5z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  filter: (
    <path
      d="M4.5 5.25h15m-12 6h9m-6 6h3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  layers: (
    <path
      d="M12 3.75l8.25 4.5L12 12.75 3.75 8.25zM3.75 12.75L12 17.25l8.25-4.5M3.75 17.25L12 21.75l8.25-4.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  network: (
    <path
      d="M12 6a3 3 0 100-6 3 3 0 000 6zm6.75 3.75a3 3 0 100-6 3 3 0 000 6zm-13.5 0a3 3 0 100-6 3 3 0 000 6zm6.75 12.75a3 3 0 100-6 3 3 0 000 6zm0-9a3 3 0 100-6 3 3 0 000 6zm-6.75 9a3 3 0 100-6 3 3 0 000 6zm13.5 0a3 3 0 100-6 3 3 0 000 6z"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  shield: (
    <path
      d="M12 2.25L4.5 5.25v6c0 5.25 3.19 8.64 7.5 10.5 4.31-1.86 7.5-5.25 7.5-10.5v-6z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  home: (
    <>
      <path
        d="M3 11.25L12 3l9 8.25"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 13.5V21h10.5v-7.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  briefcase: (
    <path
      d="M8.25 6.75V5.25A1.5 1.5 0 019.75 3.75h4.5a1.5 1.5 0 011.5 1.5v1.5m5.25 0h-18a1.5 1.5 0 00-1.5 1.5v9a1.5 1.5 0 001.5 1.5h18a1.5 1.5 0 001.5-1.5v-9a1.5 1.5 0 00-1.5-1.5zM2.25 12h19.5"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  pulse: (
    <path
      d="M3 12h3l2.25-6 3.5 12 2.5-6H21"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  )
};

const Icon = ({ name, className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className} aria-hidden="true">
    {paths[name] || null}
  </svg>
);

export default Icon;
